import React from 'react';
import '../styles/Contracts.css';

function Contracts() {
  return (
    <section className="contracts">
      <div className="container flex justify-center">
        <div className="contracts-content">
          <div className="contracts-text">
            <h2>Fresh Templates Monthly</h2>
            <p>
            New contracts added every month. Your legal toolkit keeps growing with ContractWell.
            </p>
          </div>
          
          <div className="contracts-image">
            <img 
              src="/images/people.png" 
              alt="People working on contracts" 
              className="people-illustration" 
              draggable="false"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contracts;
